import React from 'react';
import { Menu } from 'antd';
import { useTranslation } from 'react-i18next';
import { RenderMenuList } from 'components/MenuList';
import { ROUTES } from 'constant';
import { IMenuList } from 'interfaces';
import { BsRecordCircle } from 'react-icons/bs';

export const MainMenu = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const MenuList: IMenuList[] = [
    {
      icon: <BsRecordCircle size="1em" color="red" />,
      key: 'CREATE_EVENT',
      exact: true,
      to: `${ROUTES.PROFILE.AGENT_ACCOUNT_SETTINGS_PAGE}${ROUTES.PROFILE.USERS_EVENTS}${ROUTES.PROFILE.CREATE_EVENT}`,
      permissions: ['user', 'super admin'],
      title: t('Create Event'),
    },
  ];

  return <Menu className={className}>{RenderMenuList(MenuList)}</Menu>;
};
